import { MOKA_INVENTORY_API } from 'api/constants';

const { INVENTORY_CLONE_OUTLET_FEATURE_FLAG_KEY } = process.env;

export const V1_CLONE_OUTLET = `${MOKA_INVENTORY_API}/v1/clone/outlet`;

export const V1_CLONE_OUTLET_FEATURE_FLAG = `${MOKA_INVENTORY_API}/v1/feature-flag/eligible/${INVENTORY_CLONE_OUTLET_FEATURE_FLAG_KEY}`;
